import { all, put, takeLatest, call, select } from 'redux-saga/effects'
import { getUserId } from '../auth/selectors'
import * as actionTypes from './action-types'
import * as userActionTypes from '../auth/action-types'
import * as actionTypesError from '../errors/action-types'
import { fetchCountries, setUserLocale, fetchCPV, fetchDocuments } from './api'
import { orderCountries } from './business'
import { LOCALES_TO_API, LOCALES_FROM_API } from 'utils/apiLocales'
import { saveLocale } from 'services/locale'

function* countriesSaga() {
  try {
    const response = yield call(fetchCountries)
    const orderedCountries = orderCountries(response._embedded)
    yield put({ type: actionTypes.COUNTRIES_SUCCESS })
    yield put({
      type: actionTypes.SET_COUNTRIES_INFORMATION,
      payload: orderedCountries,
    })
  } catch (e) {
    yield put({ type: actionTypes.COUNTRIES_ERROR })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

function* setLocaleSaga({ payload: { locale } }) {
  const userId = yield select(getUserId)

  if (!userId) {
    return
  }

  const localeToAPI = LOCALES_TO_API[locale]

  try {
    yield call(setUserLocale, userId, localeToAPI)
    yield put({ type: userActionTypes.GET_USER_INFO, payload: { userId } })
    yield call(initSagas)
  } catch (e) {
    yield put({ type: actionTypes.SET_LOCALE_ERROR })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

function* storeLocaleSaga({ payload }) {
  if (payload.locale) {
    const locale = LOCALES_FROM_API[payload.locale]
    yield call(saveLocale, locale)
  }
}

function* CPVSaga() {
  try {
    const response = yield call(fetchCPV)
    yield put({ type: actionTypes.CPV_SUCCESS })
    yield put({
      type: actionTypes.SET_CPV_INFORMATION,
      payload: response._embedded,
    })
  } catch (e) {
    yield put({ type: actionTypes.CPV_ERROR })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

function* documentsSaga() {
  try {
    const response = yield call(fetchDocuments)
    yield put({ type: actionTypes.DOCUMENTS_SUCCESS })
    yield put({
      type: actionTypes.SET_DOCUMENTS,
      payload: response._embedded,
    })
  } catch (e) {
    yield put({ type: actionTypes.DOCUMENTS_ERROR })
    yield put({ type: actionTypesError.ERROR, payload: { error: e } })
  }
}

function* initSagas() {
  yield put({ type: actionTypes.SET_IS_CONFIG_LOADED, payload: false })
  yield call(countriesSaga)
  yield call(CPVSaga)
  yield call(documentsSaga)
  yield put({ type: actionTypes.SET_IS_CONFIG_LOADED, payload: true })
}

export default function* rootSaga() {
  yield all([
    takeLatest(actionTypes.COUNTRIES, countriesSaga),
    takeLatest(actionTypes.INIT_CONFIG, initSagas),
    takeLatest(actionTypes.SET_LOCALE, setLocaleSaga),
    takeLatest(userActionTypes.SET_USER, storeLocaleSaga),
    takeLatest(actionTypes.CPV, CPVSaga),
    takeLatest(actionTypes.DOCUMENTS, documentsSaga),
  ])
}
